import { useTranslation } from 'react-i18next'

import { EMPTY_OBJECT } from '../../../../constants/common'
import { Widget, WidgetHeaderContentActionsAddButton } from '../../../Widget'
import { useRequestProfileContext } from '../../RequestProfile.hooks'
import { RequestProfileWidgetKey } from '../RequestProfileWidget.constants'

import { useRequestProfileWidgetSideWorkersData } from './RequestProfileWidgetSideWorkers.hooks'
import { RequestProfileWidgetSideWorkersContent } from './RequestProfileWidgetSideWorkersContent'

import * as styles from './RequestProfileWidgetSideWorkers.module.css'

function RequestProfileWidgetSideWorkers({ isSkeleton }) {
  const { t } = useTranslation()

  const { handleCloseModal, modal, requestData, requestSideWorkers } =
    useRequestProfileContext()

  const { formInitialValues, handleSubmit } =
    useRequestProfileWidgetSideWorkersData({ requestId: requestData?.id })

  const canEdit = requestData?.permissions?.can_edit_workers

  const hasItems = requestSideWorkers.length > 0

  return (
    <Widget
      contentContainerProps={{
        className: styles.content,
      }}
      headerProps={{
        contentProps: {
          actionsProps:
            canEdit && hasItems
              ? EMPTY_OBJECT
              : {
                  ...(hasItems ? EMPTY_OBJECT : { ExpandButton: null }),
                  AddButton:
                    canEdit && !hasItems
                      ? WidgetHeaderContentActionsAddButton
                      : null,
                  EditButton: null,
                  addButtonProps: {
                    tooltipKey:
                      'RequestProfile.SideWorkersWidgetAddButtonTooltipKey',
                  },
                },
        },
      }}
      isSkeleton={isSkeleton}
      qaName={RequestProfileWidgetKey.SIDE_WORKERS}
      title={t('RequestProfile.SideWorkersWidgetTitleKey')}
    >
      <RequestProfileWidgetSideWorkersContent
        initialValues={formInitialValues}
        modal={modal}
        requestId={requestData?.id}
        sideWorkers={requestSideWorkers}
        onClose={handleCloseModal}
        onSubmit={handleSubmit}
      />
    </Widget>
  )
}

export default RequestProfileWidgetSideWorkers
